export default {
  'invoicePaymentCondition.label.payments': 'Payments',
  'invoicePaymentCondition.label.exchangeValue': 'Exchange Value',
  'invoicePaymentCondition.label.billingData': 'Billing Data',
  'invoicePaymentCondition.label.invoiceNumber': 'Invoice Number',
  'invoicePaymentCondition.label.originalValue': 'Original Value',
  'invoicePaymentCondition.label.discountValue': 'Discount Value',
  'invoicePaymentCondition.label.netValue': 'Net value',

  'invoicePaymentCondition.column.paymentType': 'Payment Type',
  'invoicePaymentCondition.column.value': 'Value',
  'invoicePaymentCondition.column.flagCard': 'Flag Card',
  'invoicePaymentCondition.column.authorizationNumber': 'Authorization Number',
  'invoicePaymentCondition.column.installmentNumber': 'Installment Number',
  'invoicePaymentCondition.column.expirationDate': 'Expiration Date',
  'invoicePaymentCondition.column.installmentValue': 'Installment Value',

  'invoicePaymentCondition.button.newPayment': 'New Payment',
  'invoicePaymentCondition.button.newInstallment': 'New Installment',
  'invoicePaymentCondition.button.multipleInstallments':
    'Multiple Installments',
};
